export const environment = {
  production: true,
  buildId: '3861024478023671',
  configFile: 'config.json',
};
